export var RichTextToolbarType;
(function (RichTextToolbarType) {
    RichTextToolbarType["normal"] = "normal";
    RichTextToolbarType["none"] = "none";
})(RichTextToolbarType || (RichTextToolbarType = {}));
export var RichTextMode;
(function (RichTextMode) {
    RichTextMode["editor"] = "editor";
    RichTextMode["preview"] = "preview";
})(RichTextMode || (RichTextMode = {}));
